import { useEffect } from "react";

export const useHideScrollbar = (backgroundColor: string) => {
  useEffect(() => {
    const style = document.getElementsByTagName("body")[0].style;
    style.overflowY = "hidden";

    const origScrollbarColor =
      document.documentElement.style.getPropertyValue("--scrollbar-color");

    document.documentElement.style.setProperty(
      "--scrollbar-color",
      backgroundColor
    );
    return () => {
      style.overflowY = "";
      document.documentElement.style.setProperty(
        "--scrollbar-color",
        origScrollbarColor
      );
    };
  }, []);
};

export const HideScrollbar = ({ bgColor }: { bgColor: string }) => {
  useHideScrollbar(bgColor);
  return null;
};
